import useOpenable from "@Front/Hooks/useOpenable";
import { useCloseOpenableOnEscape } from "@Front/Hooks/useCloseOpenableOnEscape";
import { useCloseOpenableOnOutsidePointer } from "@Front/Hooks/useCloseOpenableOnOutsidePointer";
import { useCloseOpenableOnPageShow } from "@Front/Hooks/useCloseOpenableOnPageShow";
import { useCloseOpenableOnRouteChange } from "@Front/Hooks/useCloseOpenableOnRouteChange";
import { WindowStore } from "@Front/Stores/WindowStore";
import { UserIcon } from "@heroicons/react/24/outline";
import { useEffect, useRef } from "react";

import IconButton from "../../IconButton";
import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";
import classes from "./classes.module.scss";
import ProfileModal from "./ProfileModal";

const headerBreakpoint = 1023;

export default function Profile(): React.ReactElement {
	const rootRef = useRef<HTMLDivElement>(null);
	const { isOpen, toggle, close } = useOpenable();
	useCloseOpenableOnRouteChange(isOpen, close);
	useCloseOpenableOnPageShow(isOpen, close);
	useCloseOpenableOnEscape(isOpen, close);
	useCloseOpenableOnOutsidePointer(isOpen, close, rootRef);

	useEffect(() => {
		const onResize = (window: Window): void => {
			if (window.innerWidth < headerBreakpoint && isOpen) close();
		};

		const windowResizeSubscription = WindowStore.getInstance().onResize((window) => onResize(window));

		return (): void => {
			windowResizeSubscription();
		};
	}, [close, isOpen]);

	return (
		<div className={classes["root"]} ref={rootRef}>
			<IconButton
				icon={<UserIcon />}
				onClick={toggle}
				ariaLabel={COMMON_UI_I18N.iconButtonAccessibilityLabels.openUserMenu}
			/>
			<ProfileModal isOpen={isOpen} closeModal={close} />
		</div>
	);
}
